import React from 'react'
import Banner from '../../components/Banner/Banner'
import './about.css'
import { motion } from 'framer-motion';
import bannerImg2 from '../../images/about-page.webp'

const About = () => {
  return (
    <motion.div 
      initial={{opacity: 0}} 
      animate={{opacity: 1}} 
      exit={{opacity: 0}} 
      className="container about_us" 
      id="about"
    >
      <h2>About Us</h2>
      <Banner 
        comp="home" 
        title="Our Mission at Leduc Taxi" 
        description="At Leduc Taxi, our goal is to provide top-tier transportation services in Leduc. From airport transfers to personalized KMs schemes, we ensure every ride is cost-effective, comfortable, and smoke-free. Enjoy the ease of online booking and well-maintained vehicles that prioritize your needs." 
        bannerImg={bannerImg2} 
      />
    
      <h2>Why Choose Leduc Taxi?</h2>
      <div className="timeline">
        <div className="cont left">
          <div className="text_box">
            <p>With advanced dispatch technology, we deliver faster and more accurate services, ensuring comfortable rides for airport transfers and local commutes in Leduc.</p>
            <span className="left_arrow"></span>
          </div>
        </div>
        <div className="cont right">
          <div className="text_box">
            <p>Our team of professional drivers, backed by a cutting-edge information system, guarantees reliable pickups and drop-offs for every ride, including airport services.</p>
            <span className="right_arrow"></span>
          </div>
        </div>
        <div className="cont left">
          <div className="text_box">
            <p>We make trip planning easier with tools like route maps and fare estimates. Book online or plan your travel effortlessly to and from Edmonton International Airport.</p>
            <span className="left_arrow"></span>
          </div>
        </div>
        <div className="cont right">
          <div className="text_box">
            <p>With our secure payment system, you can conveniently pay via credit or debit card. Whether booking online or using our tailored KMs scheme, Leduc Taxi ensures your transactions are safe.</p>
            <span className="right_arrow"></span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default About
